<template>
	<v-app id="erp_app" ref="erp_app">
		<FlashNotice />
		<HeaderComponent ref="erpHeader" @headerParent="openSideFeatureMenu" />
		<!-- :departments="departments"
			:auto_notification_count="auto_notification_count"
			:message_notification_count="message_notification_count"
			:currentUser="currentUser" -->
		<div class="main-body">
			<!-- <SideFeatureMenu /> -->
			<v-sheet elevation="0" class="flex-grow">
				<router-view></router-view>
			</v-sheet>
		</div>
	</v-app>
</template>

<script>
import FlashNotice from "./erp_src/view/shared/FlashNotice.vue"
import HeaderComponent from "./erp_src/view/shared/ErpHeaderComponent.vue"
import TranslucentLoader from "./erp_src/view/shared/TranslucentLoader.vue"
// import SideFeatureMenu from "./erp_src/view/shared/SideFeaturesMenu.vue"

export default {
	components: {
		HeaderComponent,
		FlashNotice,
		// SideFeatureMenu,
		TranslucentLoader,
	},
	data() {
		return {
			departments: [],
			department: {},
			features: [],
			isSideOpen: false,
			message_count: 0,
			currentUser: {},
		}
	},
	methods: {
		openSideFeatureMenu(dep) {
			// this.features = dep.features
			// this.department = dep
			// this.isSideOpen = true
		},
	},
	watch: {},
}
</script>

<style lang="scss">
$xs: 600px;
body {
	background: #fefefe;
}
.date-picker {
	.v-date-picker-table--date {
		height: auto;
	}
}
.main-body {
	display: flex;
	height: calc(100vh - 80px);
}
@media (max-width: 1260px) {
	.main-body {
		height: calc(100vh - 70px);
	}
}

a {
	&:hover {
		opacity: 0.7;
	}
}

// .main-container{

// }

.v-application {
	p {
		margin-bottom: 0;
	}
}

.flex-grow {
	flex-grow: 1;
	flex-shrink: 1;
	// max-width: 100vw;
	width: calc(100vw - 276px);
	padding: 0 8px;
}
@media (max-width: $xs) {
	.flex-grow {
		width: calc(100% - 20px);
	}
}
.color-white {
	.v-app-bar-title__content,
	.v-app-bar-title__placeholder {
		color: white !important;
	}
}

.table-container {
	width: 100%;
	overflow-x: scroll;
	.v-data-table {
		width: auto;
	}
}

.checkbox-wrapper {
	.v-messages__wrapper {
		position: relative;
		.v-messages__message {
			position: absolute;
			word-break: keep-all !important;
		}
	}
}

.v-date-picker-table {
	height: auto;
}
</style>
